export default {
  t1: 'China Academy of Railway Sciences Group Co., Ltd. 𞓜 Beijing ICP preparation No. 20012158-2',
  t2: 'Copyright © 2019 | China Academy of Railway Sciences Group Co., Ltd. all rights reserved | Internet access involving state secrets is strictly prohibited',
  t3: 'common problem',
  t4: 'Service Information',
  t5: 'Site map',
  t6: 'portal site',
  t7: 'Internal mailbox',
  t8: 'Safety tips'
}
